/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_ActivateInputs */

const cs_templates_activate = /** @type {(inputs: Templates_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivovat`)
};

const en_templates_activate = /** @type {(inputs: Templates_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate`)
};

/**
* | output |
* | --- |
* | "Activate" |
*
* @param {Templates_ActivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_activate = /** @type {((inputs?: Templates_ActivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_ActivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_activate(inputs)
	return cs_templates_activate(inputs)
});